import React from "react";
import classnames from "classnames";

import { Moment } from "../../utils";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import CoterieButton from '../../coterie/components/CoterieButton';

import * as TodoActions from "../TodoActions";

const insurance = {
    float: 'right',
    'text-align': 'right'
};

class TodoList extends React.Component {
  toggleItem = item => {
    this.props.toggleTodo(item);
  };
  deleteItem = item => {
    this.props.deleteTodo(item);
  };
  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.items.length !== this.props.items.length;
  }
  render() {
    return (
      <div>
        <h5 className="todo-group-title">
          <i className={classnames("fa", "fa-" + this.props.icon)} />&nbsp;&nbsp;
          {this.props.title}
        </h5>
        <ul className="todo" ref="todoList">
          {this.props.items.map((item, idx) => {
            return (
              <li
                className={classnames({ complete: item.completedAt })}
                key={item.id}
                data-todo-id={item.id}
              >
                <span className="handle">
                  <label className="checkbox">
                    <input
                      type="checkbox"
                      defaultChecked={item.completedAt}
                      name="checkbox-inline"
                    />
                    <i />
                  </label>
                </span>
                <p>
                  <strong>Assignment #{idx + 1}</strong>
                  <em> - </em>
                  <big>{item.title}</big>
                  <span className="text-muted">{item.description}</span>
                  <span className="date">
                    Listed <Moment date={item.createdAt} />
                  </span>
                </p>
              {item.requiresInsurance && <div style={insurance}>
                  <div>This assignment requires GL insurance</div>
                  <CoterieButton cssClass="custom" text="Click here to get a quote" />
              </div>}
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}



export default connect(
  store => store.todo,
  dispatch => bindActionCreators(TodoActions, dispatch)
)(TodoList);
